/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AssessmentResponse } from './assessmentResponse';

export type GenericApiResponseAssessmentResponseData = AssessmentResponse | null;
